import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Heading, Button, Flex } from '@chakra-ui/react';
import { useDisclosure } from '@chakra-ui/react';
import { FaServer } from 'react-icons/fa';

import PaginationControls from 'components/table/PaginationControls';
import LoadingSpinner from 'components/table/LoadingSpinner';

import { useColors } from './components/colors';
import SuppliersTable from './components/SuppliersTable';
import SftpSettingsModal from './components/SftpSettingsModal';

import { getSuppliersApi } from 'features/suppliers/suppliers.api';

const Suppliers = () => {
  const dispatch = useDispatch();
  const itemsPerPage = 5;
  const { backgroundCardColor, textColor } = useColors();
  const { isOpen: isSftpModalOpen, onOpen: onSftpModalOpen, onClose: onSftpModalClose } = useDisclosure();

  const { suppliers, totalPages, currentPage, getSuppliersStatus } = useSelector(
    (state) => state.suppliers,
  );

  useEffect(() => {
    dispatch(getSuppliersApi({ page: currentPage, limit: itemsPerPage }));
  }, [dispatch, currentPage]);

  const handlePageChange = (page) => {
    dispatch(getSuppliersApi({ page, limit: itemsPerPage }));
  };

  return (
    <Box px={{ base: 4, md: 10 }} py={{ base: 6, md: 8 }} mt="50px">
      <Flex justify="space-between" align="center" mb={4} wrap="wrap" gap={3}>
        <Heading as="h1" size="xl" color={textColor}>
          Overview
        </Heading>
        <Button
          leftIcon={<FaServer />}
          colorScheme="blue"
          variant="outline"
          size="md"
          onClick={onSftpModalOpen}
          fontWeight="500"
          borderColor="blue.300"
          _hover={{ bg: 'blue.50', borderColor: 'blue.400' }}
        >
          SFTP Settings
        </Button>
      </Flex>

      <Box bg={backgroundCardColor} borderRadius="lg" boxShadow="sm" p={4}>
        {getSuppliersStatus === 'pending' ? (
          <LoadingSpinner />
        ) : (
          <>
            <SuppliersTable suppliers={suppliers} />
            <PaginationControls
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </>
        )}
      </Box>

      <SftpSettingsModal isOpen={isSftpModalOpen} onClose={onSftpModalClose} />
    </Box>
  );
};

export default Suppliers;
